<template>
  <slot></slot>
  <modal :id="modalId" :title="title">
    <form :id="formId" :action="action" method="POST">

      <div class="form-group row">
        <label class="col-form-label col-sm-3">Inspected:</label>
        <div class="col-sm-9 mt-1">
          <label class="radio-inline pt-0">
            <input type="radio" name="inspected" id="inspected1" :value="true" v-model="data.inspected"> Yes
          </label>
          <label class="radio-inline pt-0">
            <input type="radio" name="inspected" id="inspected2" :value="false" v-model="data.inspected"> No
          </label>
        </div>
      </div>
      <div class="form-group row" :class="{'has-error': !data.inspectedAt}">
        <label for="inspected_at" class="col-form-label col-sm-3">{{ inspectedLabel }}</label>
        <div class="col-sm-9">
          <datepicker
            v-model="data.inspectedAt"
            :min-date="minDate"
            :max-date="maxDate"
            :invalid-state="!data.inspectedAt"
            name="inspected_at">
          </datepicker>
        </div>
      </div>
      <div class="form-group row" :class="{'has-error': commentsNeeded}">
        <label for="comments" class="col-form-label col-sm-3">Comments:</label>
        <div class="col-sm-9">
          <textarea class="form-control form-control-sm" id="comments" name="comments"
                    placeholder="Enter delay reason or any other comments..." rows="5"
                    maxlength="1000" v-model="data.comments">
          </textarea>
          <span class="text-secondary small">The maximum number of characters allowed is 1000.</span>
        </div>
      </div>

      <input type="hidden" name="_method" value="PATCH">
      <input type="hidden" name="_token" :value="$csrf_token">
    </form>

    <template #footer>
      <button type="button" class="btn btn-default" @click="hideModal">
        <i class="fa fa-fw fa-close"></i> Cancel
      </button>
      <button type="submit" class="btn btn-primary" :disabled="!submitEnable" name="submit_inspected" :form="formId">
        <i class="fa fa-fw fa-save"></i> Submit
      </button>
    </template>

  </modal>
</template>

<script>
import HasModal from "./../mixins/HasModal";
export default {

  /**
   *
   * Modal form used to set claim loss inspection date and related data.
   *
   * Input properties:
   *
   * modalId - custom id for modal component.
   * action  - form action URL.
   * title   - form title.
   *
   * Usage examples:
   *
   * <inspected-claim-modal modal-id="inspectedModal"
   *                        action="{{ route('claims.submit', compact('claim')) }}"
   *                        title="Loss Inspection">
   *   <a href="#" class="" v-modal="'inspectedModal'">Update</a>
   * </inspected-claim-modal>
   */

  mixins: [HasModal],

  props: {

    // Modal dialog id.
    modalId: {
      type: String,
      default: 'inspectedModal'
    },

    // Form action URL.
    action: {
      type: String,
      default: ""
    },

    // Form title.
    title: {
      type: String,
      default: ""
    },

    inspected: {
      type: Boolean,
      default: false
    },

    inspectedAt: {
      type: String,
      default: ""
    },

    comments: {
      type: String,
      default: ""
    },
  },

  /**
   * Variables (models).
   */
  data() {
    return {
      data: {
        inspected: this.inspected,
        inspectedAt: this.inspectedAt,
        comments: this.comments,
      },
      minDate: moment(new Date()).set({hour: 0, minute: 0, second: 0, millisecond: 0}).format('MM/dd/yyyy'),
      maxDate: null,
    }
  },

  /**
   * Computed values
   */
  computed: {

    formId() {
      return this.modalId + "-form"
    },

    submitEnable() {
      return this.data.inspectedAt && !this.commentsNeeded;
    },

    commentsNeeded() {
      return !this.data.inspected && !this.data.comments.trim().length;
    },

    inspectedLabel() {
      return this.data.inspected ? 'Inspection Date:' : 'Scheduled Inspection:';
    }

  },

  watch: {
    'data.inspected': function (val) {
      if (val === true) {
        this.minDate = null;
        this.maxDate = moment(new Date()).set({hour: 23, minute: 59, second: 59, millisecond: 999}).format('MM/dd/yyyy');
      } else {
        this.minDate = moment(new Date()).set({hour: 0, minute: 0, second: 0, millisecond: 0}).format('MM/dd/yyyy');
        this.maxDate = null;
      }

      this.data.inspectedAt = '';
    },
  }
}
</script>
